module.exports = __webpack_public_path__ + "static/media/detail9.2b5ad7fe.jpg";